import script from "./ReportsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReportsView.vue?vue&type=script&setup=true&lang=ts"

import "./ReportsView.vue?vue&type=style&index=0&id=45a05802&lang=sass"

const __exports__ = script;

export default __exports__